import { Image } from 'react-datocms/image';

import type { ImagePropTypes } from 'react-datocms/image';

type Props = ImagePropTypes;

export function CmsImage(props: Props) {
  return <Image {...props} />;
}
